import React, { useContext, useEffect } from 'react';
import { RouterContext } from '../../../contexts/routerContext';
import { FiCheckCircle } from 'react-icons/fi'
import { AlertContainer } from './styles';

function AlertMessage() {
    const { setRouter, alertMessage, setAlertMessage } = useContext(RouterContext);
    useEffect(() => {
        setTimeout(() => {
            setAlertMessage({
                status: '',
                message: ''
            })
        }, 5000)
    }, [])
    return (
        <AlertContainer>
            <h1>{alertMessage.message}</h1>
            <div>
                <FiCheckCircle size={40} color={alertMessage.status === 'success' ? '#06AB03' : '#FF0000'} />
            </div>
        </AlertContainer>
    );
}

export default AlertMessage;